import React from 'react';

import ProductIcon from 'app/features/landing/productComparison/components/icons/ProductIcon.styled';

const PremiumProductIcon = () => (
  <ProductIcon title="Premium" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="none"
      d="M25.9995805 2.1706845L15.5442004 17.9313712 2.0056328 11.2757714 9.2325257 33.8h34.15535L50.0715 11.2378527l-13.615663 6.6935002L25.9995805 2.1706845z"
    />
  </ProductIcon>
);

export default PremiumProductIcon;
